module.exports = __webpack_public_path__ + "img/tips-leaf.55499d52.svg";